import React from "react";

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col, Button,
} from "reactstrap";

import {getStats} from "../../components/helpers/StatsHelpers";
import {RiLineChartLine, RiTeamLine, RiUser3Line} from "react-icons/ri";
import FeaturesMatrix from "./FeaturesMatrix";
import withNavigationHook from "../../hooks/withNavigationHook";
import {SeoHelper} from "../../components/helpers/SeoHelper";

class Benefits extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  render() {
    return (
      <>
        <SeoHelper
            uri="/benefits"
            title="Benefits of The Worship Bible | Plan Scripture-Based Worship Services"
            description="Discover how The Worship Bible helps you plan seamless, scripture-based worship services. Save time, reduce stress, and create meaningful worship service plans for your church."
        />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your service plans{" "}
                        <span>benefits of the worship bible</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg={sessionStorage.getItem("customer") ? "12" : "8"}>
                      <Card className="card--hover shadow border-0">
                        <CardBody className="py-5">
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">
                                <RiLineChartLine color='#5e72e4' size="36"/>Benefits
                              </h2>
                            </Col>
                          </Row>
                          <p className="MsoNormal">
                            Worship is more than selecting songs — it is shaping a whole Act of Worship that
                            brings Scripture, prayer, proclamation, and praise together with purpose.
                            The Worship Bible is designed to help you plan worship with confidence,
                            ensuring your worship service plans serve the wider movement of worship — from gathering to sending —
                            with clarity and purpose.
                          </p>
                          <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">
                            Rooted in Scripture
                          </h3>
                          <p className="MsoNormal">
                            Unlike generic music tools, The Worship Bible helps you shape worship service plans that are
                            deeply rooted in Scripture and aligned with the whole Act of Worship.
                          </p>
                          <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">
                            Designed for Flow
                          </h3>
                          <p className="MsoNormal">
                            We know worship isn’t one-size-fits-all. That’s why we give you the freedom to rearrange
                            songs within your worship service plans with ease. Drag, drop, and fine-tune until the sequence feels
                            just right—whether it’s for a Sunday service or personal devotion. It’s your worship, your
                            way, without the hassle.
                          </p>
                          <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">
                            Save Without Limits
                          </h3>
                          <p className="MsoNormal">
                            Say goodbye to limits. As a member of The Worship Bible, you can save unlimited worship service plans
                            to your profile, keeping all your ideas organized and accessible. Unlike other platforms
                            that cap your creativity or charge extra for storage, we empower you to build and preserve
                            as many worship moments as you need—no restrictions, no hidden fees.
                          </p>
                          <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">
                            Built for Collaboration
                          </h3>
                          <p className="MsoNormal">
                            Collaboration is at the heart of worship. With The Worship Bible, you can share your
                            worship service plans via email with just a click. Send them to your ministry group, pastor, or friends,
                            ensuring everyone’s on the same page — literally. No complicated exports or third-party tools
                            required; we make staying connected simple.
                          </p>
                          <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">
                            <RiTeamLine color='#5e72e4' size="20" style={{verticalAlign: 'middle', marginRight: '6px'}}/>
                            Group subscriptions
                          </h3>
                          <p className="MsoNormal">
                            A Group subscription gives your whole church or ministry access under one subscription.
                            Invite others, share worship service plans, and plan services together.
                            Group subscriptions are £300 per year for up to 10 members.
                          </p>
                          <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">
                            Simple and Purposeful
                          </h3>
                          <p className="MsoNormal">
                            We believe technology should enhance, not complicate, your worship planning. Our platform is
                            built to be intuitive, so you can focus on creating rather than troubleshooting. From
                            signing in to managing your worship service plans, every step is streamlined—making The Worship Bible a
                            joy to use, even if you’re not tech-savvy.
                          </p>
                          <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">
                            Supporting the Worshipping Church
                          </h3>
                          <p className="MsoNormal">
                            The Worship Bible isn’t just a tool—it’s a partner in your worship journey. While some
                            competitors focus solely on functionality, we’re here to build a community. Access our Help
                            resources anytime, share feedback to shape our future, and join a growing network of worship
                            leaders and music lovers who value faith-driven innovation.
                          </p>
                          <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">
                            Accessible for Churches of All Sizes
                          </h3>
                          <p className="MsoNormal">
                            Why pay more for less? The Worship Bible offers robust features at a value that respects
                            your budget. Compared to platforms with complex pricing tiers or limited free options, we
                            provide a straightforward path to premium benefits—unlimited worship service plans, sharing, and
                            more—all designed to fit the needs of churches and individuals alike.
                          </p>
                          <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">
                            Why Choose The Worship Bible?
                          </h3>
                          <p className="MsoNormal">
                            In a crowded field of worship tools, The Worship Bible stands apart by placing Scripture,
                            structure, and the Act of Worship at the centre of every worship service plan.
                            We’re not here to overwhelm you with extras you
                            don’t need; we’re here to deliver what matters most: a platform that inspires worship,
                            supports your creativity, and connects your community. Whether you’re planning a service or
                            exploring songs for personal reflection, The Worship Bible is your trusted companion.
                          </p>
                          <p className="MsoNormal">
                            Ready to experience the difference? Sign up today and start crafting worship service plans that bring
                            worship to life.
                          </p>
                          <p className="description mt-3">
                            <a href="/register/choose-your-plan" className="font-weight-bold">
                              Start using The Worship Bible
                            </a>{" "}
                            to build, save, and edit unlimited curated worship service plans using all of our
                            {" "}{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books").value}{" "}
                            song books.
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                    {!sessionStorage.getItem("customer") &&
                        <Col lg="4">
                        <Card className="card--hover shadow border-0">
                          <CardBody className="py-5">
                            <Row>
                              <Col>
                                <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                  <RiUser3Line color='#5e72e4' size="36"/>Get started
                                </h2>
                              </Col>
                            </Row>
                            <p className="description mt-3">
                              Get started with The Worship Bible to build, save, and edit unlimited curated worship service plans
                              {" "}{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books").value}{" "}
                              song books.
                            </p>
                            {/*<RegistrationForm/>*/}
                            <div className="text-center">
                              <Button
                                  id="paymentSelectionButton"
                                  className="mt-4"
                                  color="primary"
                                  type="button"
                                  onClick={() => this.props.navigation("/register/choose-your-plan")}
                              >
                                Get started
                              </Button>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    }
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        <FeaturesMatrix/>
        {/*</main>*/}

      </>
    );
  }
}

export default withNavigationHook(Benefits);
